export const plansDictionary = {
  planNames: { wordsmith: 'Wordsmith', 'wordsmith-yearly': 'Wordsmith' },
  renews: { month: 'monthly', year: 'annually', lifetime: '' },
  price: {
    month: { wordsmith: 39, 'wordsmith-yearly': 0 },
    year: { wordsmith: 299, 'wordsmith-yearly': 300 },
    lifetime: { wordsmith: 0, 'wordsmith-yearly': 600 },
  },
} as const;
